/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */
import { defineStore } from "pinia";

/**
 * This is a Pinia store definition named "ScreenStore".
 * It has a state with properties screenWidth and screenHeight,
 * and actions to update these properties with the current window dimensions.
 * It also has getters to check if the screen is very small, small, or in portrait orientation.
 *
 * @type {StoreDefinition<"ScreenStore", {screenWidth: number, screenHeight: number}, {isVerySmallScreen: (function(*): boolean), isSmallScreen: (function(*): boolean), isPortrait: (function(*): boolean)}, {updateScreenSize(): void}>}
 */
export const useScreenStore = defineStore("ScreenStore", {
  state: () => ({
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
  }),
  actions: {
    updateScreenSize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },
  },
  getters: {
    isVerySmallScreen: (state) => state.screenWidth <= 480,
    isSmallScreen: (state) => state.screenWidth <= 768,
    isPortrait: (state) => state.screenHeight > state.screenWidth,
  },
});
